import { InputHTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

require('./TextField.css');

export type Props = InputHTMLAttributes<HTMLInputElement> & {
    id: string;
    required?: boolean;
    label?: string;
    labelKey?: string;
    error?: string;
    fixedPrefix?: string;
    fixedSuffix?: string;
};

// KILL: Convert all usages into TextField, delete this, and remove redux-form
export const LegacyTextField = ({ id, type, label, labelKey, input, error, required, ...otherProps }: Props & { input: { value: string; onChange: any } }) => {
    const { t } = useTranslation();
    return (
        <div className={ `${required ? 'required' : ''} field text-field` }>
            { (label || labelKey) &&
                <label htmlFor={ id }>
                    { label || t(labelKey!) }
                </label>
            }
            <input
                id={ id }
                type={ type }
                { ...input }
                { ...otherProps }
            />
            { error &&
                <div className="error">
                    { error }
                </div>
            }
        </div>
    );
};

export const TextField = ({ required, id, className, label, labelKey, disabled, error, type = 'text', fixedPrefix, fixedSuffix, ...otherProps }: Props) => {
    const { t } = useTranslation();
    const fixedLabel = fixedSuffix || fixedPrefix;

    return (
        <div
            id={ id && `${id}-field` }
            className={ `${required ? 'required' : ''} field text-field ${className || ''}` }
        >
            { (label || labelKey) &&
                <label htmlFor={ id } className={ disabled ? 'disabled' : '' }>
                    { label || t(labelKey!) }
                </label>
            }
            { fixedLabel
                ?
                    <div className={ `ui ${fixedSuffix ? 'right' : ''} labeled input` }>
                        { fixedPrefix &&
                            <div className="ui label">
                                { fixedPrefix }
                            </div>
                        }
                        <input
                            id={ id }
                            type={ type }
                            disabled={ disabled }
                            { ...otherProps }
                        />
                        { fixedSuffix &&
                            <div className="ui label">
                                { fixedLabel }
                            </div>
                        }
                    </div>
                :
                    <input
                        id={ id }
                        type={ type }
                        disabled={ disabled }
                        { ...otherProps }
                    />
            }
                
            { error &&
                <div className="error">
                    { error }
                </div>
            }
        </div>
    );
};
